import { useContext } from 'react';
import { useQuery } from 'react-query';
import { FetchContext } from 'context/FetchContext';

function useStreamsList(data = {}) {
  const { enabled = false, dropdown = false, configs = {} } = data;
  const { privateFetch } = useContext(FetchContext);

  const getStreams = async () => {
    // If configs is not provided, we still need to handle params
    const requestConfigs = {
      ...configs,
      params: {
        ...(configs.params || {}),
        mode: dropdown ? 'DROPDOWN' : undefined,
      },
    };

    const res = await privateFetch.get('/v1/admin/streams', requestConfigs);
    return res.data;
  };

  return useQuery(['streams-list', { data }], getStreams, {
    enabled,
    keepPreviousData: true,
  });
}

export default useStreamsList;
